export var BeneficiaryStatus;
(function (BeneficiaryStatus) {
    BeneficiaryStatus["WORKING"] = "WORKING";
    BeneficiaryStatus["INACTIVE"] = "INACTIVE";
})(BeneficiaryStatus || (BeneficiaryStatus = {}));
export var BeneficiaryStatusInProduct;
(function (BeneficiaryStatusInProduct) {
    BeneficiaryStatusInProduct["ACTIVE"] = "ACTIVE";
    BeneficiaryStatusInProduct["INACTIVE"] = "INACTIVE";
})(BeneficiaryStatusInProduct || (BeneficiaryStatusInProduct = {}));
export var CardStatus;
(function (CardStatus) {
    CardStatus["ISSUED"] = "ISSUED";
    CardStatus["NOT_ISSUED"] = "NOT_ISSUED";
})(CardStatus || (CardStatus = {}));
